export default {

  transportList: [],
  transportDetails: [],

  gifts: [],
  foodList: [],
  calendarList: [],

};
